import React from 'react'
import { Link } from 'gatsby'
import { useSelector, useDispatch } from 'react-redux'

import NavSocials from '~/components/features/header/navSocials'
import MainNav from '~/components/features/header/mainNav'

import trads from '~/intl/trads.json'

import { User } from '~/icons/User'

import { changeLang, setHasMainNavOpen } from '~/store/actions'

import scrollManager from '~/utils/scrollManager'

const PanelNav = ({ frUrl, enUrl, isOpen, togglePanel }) => {
  const lang = useSelector((state) => state.lang)
  const dispatch = useDispatch()

  const click = () => {
    dispatch(setHasMainNavOpen(false))
    scrollManager.restart()
  }

  return (
    <div
      className={`panel-nav panel-nav--menu bg-purple flex ${isOpen ? 'is-visible' : ''}`}
    >
      <div className="fluid-grid md:flex">
        <div className="row flex-grow md:flex-grow-0">
          <div className="col-12 md-col-8 md-col-offset-2 md:flex md:flex-col md:justify-between">
            <MainNav togglePanel />

            <div className="md:flex items-center text-14 md:text-base font-semi-bold panel-nav__bottom-links mobile-subnav-hidden">
              <ul className="md:flex items-center">
                <li className="mb-6 md:mb-0 md:mr-8">
                  <Link
                    onClick={click}
                    to={lang === 'fr' ? '/contact' : '/en/contact'}
                  >
                    {trads[lang]?.header?.contact}
                  </Link>
                </li>
                <li className="mb-6 md:mb-0 md:mr-8">
                  <Link
                    onClick={click}
                    to={lang === 'fr' ? '/nos-competences' : '/en/our-skills/'}
                  >
                    {trads[lang]?.header?.joinUs}
                  </Link>
                </li>
                <li className="-ml-2 md:ml-0">
                  <a
                    onClick={click}
                    href="https://portail.terega.fr/star-app/accueil"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center"
                  >
                    <User className="icon-white" width="32" height="32" />
                    {trads[lang]?.header?.customerPortal}
                  </a>
                </li>
              </ul>

              <ul className="md:flex md:ml-11 panel-nav__lang">
                <li className=" mb-4 md:mb-0 md:mr-10">
                  <Link
                    className={`${lang === 'fr' ? 'is-active' : ''} ${frUrl === null && 'is-disabled'}`}
                    to={frUrl === null ? '/' : frUrl}
                    onClick={() => dispatch(changeLang('fr'))}
                  >
                    Français
                  </Link>
                </li>
                <li>
                  <Link
                    className={`${lang === 'en' ? 'is-active' : ''} ${enUrl === null && 'is-disabled'}`}
                    to={enUrl === null ? '/en' : enUrl}
                    onClick={() => dispatch(changeLang('en'))}
                  >
                    English
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <NavSocials />
      </div>
    </div>
  )
}

export default PanelNav
